module.exports = __webpack_public_path__ + "static/media/pasta.b216ac6a.jpg";